'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

const React = require('react');
const React__default = _interopDefault(React);
const styled = require('styled-components');
const styled__default = _interopDefault(styled);
const universal_color = require('../../style/universal.color.js');
const skeleton = require('../Skeleton/skeleton.js');
const image = require('../Image/image.js');
const teamLogo_types = require('./teamLogo.types.js');

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var TeamLogoFallback = 'https://www.mlbstatic.com/team-logos/team-cap-on-light/000.svg';

var constructTeamLogoURL = function constructTeamLogoURL(teamId, teamLogoType, darkMode) {
  var baseUrl = "https://www.mlbstatic.com/team-logos";
  return teamLogoType === 'team' ? "".concat(baseUrl, "/").concat(teamId, ".svg") : "".concat(baseUrl, "/team-").concat(teamLogoType, "-on-").concat(darkMode ? 'dark' : 'light', "/").concat(teamId, ".svg");
};

var TeamLogo = function TeamLogo(props) {
  var _props$src = props.src,
      src = _props$src === void 0 ? '' : _props$src,
      teamId = props.teamId,
      _props$teamLogoType = props.teamLogoType,
      teamLogoType = _props$teamLogoType === void 0 ? teamLogo_types.TeamLogoTypes.CAP : _props$teamLogoType,
      _props$darkMode = props.darkMode,
      darkMode = _props$darkMode === void 0 ? false : _props$darkMode,
      _props$rounded = props.rounded,
      rounded = _props$rounded === void 0 ? false : _props$rounded,
      _props$errorImageSrc = props.errorImageSrc,
      errorImageSrc = _props$errorImageSrc === void 0 ? TeamLogoFallback : _props$errorImageSrc,
      _props$backgroundColo = props.backgroundColor,
      backgroundColor = _props$backgroundColo === void 0 ? universal_color.transparent : _props$backgroundColo,
      _props$theme = props.theme,
      theme = _props$theme === void 0 ? {} : _props$theme,
      border = props.border,
      isLoading = props.isLoading,
      width = props.width,
      height = props.height,
      _props$skeletonRounde = props.skeletonRounded,
      skeletonRounded = _props$skeletonRounde === void 0 ? false : _props$skeletonRounde,
      dataAttr = props.dataAttr;
  var defaultTestIds = {
    'data-mlb-test': 'teamLogos',
    'data-testid': 'teamLogos'
  };
  var providedSrc = teamId ? constructTeamLogoURL(teamId, teamLogoType, darkMode || theme.dark) : src;
  var TeamLogoUI = isLoading ? /*#__PURE__*/React__default.createElement(skeleton, {
    width: width,
    height: height || width,
    isCircle: skeletonRounded || rounded,
    margin: 0
  }) : /*#__PURE__*/React__default.createElement(image, _extends({}, props, {
    key: teamId,
    src: providedSrc,
    rounded: rounded,
    errorImageSrc: errorImageSrc,
    backgroundColor: backgroundColor,
    border: border,
    padding: rounded && '10%' || undefined,
    dataAttr: _objectSpread(_objectSpread({}, defaultTestIds), dataAttr)
  }));
  return TeamLogoUI;
};

const TeamLogo$1 = styled.withTheme(TeamLogo);

module.exports = TeamLogo$1;
